import React from 'react';
import { MEMBERSHIP_LEVEL } from './orgStructureSelectorUtils';

/**
 * Compact membership title picker (no logo — text-only tiles).
 */
export default function MembershipAssignmentPicker({
  assignments,
  selectedId,
  onSelect,
  sectionName,
}) {
  const level = MEMBERSHIP_LEVEL;
  const safe = Array.isArray(assignments) ? assignments : [];

  if (safe.length === 0) {
    return (
      <div className="members-onboarding-structure__membership-picker">
        <p className="members-onboarding-structure__membership-empty" role="status">
          No membership title is available for
          {sectionName ? ` « ${sectionName} »` : ' this section'} yet. Contact an administrator.
        </p>
      </div>
    );
  }

  return (
    <div className="members-onboarding-structure__membership-picker">
      <h3 className="members-onboarding-structure__membership-heading">{level.heading}</h3>
      {safe.length === 1 ? (
        <p className="members-onboarding-structure__membership-hint" role="status">
          One title is available for this section — select it to continue.
        </p>
      ) : null}
      <ul
        className="members-onboarding-structure__membership-grid"
        role="listbox"
        aria-label={level.heading}
      >
        {safe.map((row) => {
          const isSelected = selectedId != null && Number(selectedId) === Number(row.id);
          const cardClassName =
            'members-onboarding-structure__membership-card' +
            (isSelected ? ' members-onboarding-structure__membership-card--selected' : '');
          return (
            <li key={row.id} className="members-onboarding-structure__membership-item">
              <button
                type="button"
                role="option"
                aria-selected={isSelected}
                className={cardClassName}
                onClick={() => onSelect(row.id)}
              >
                <span className="members-onboarding-structure__membership-label">{row.name}</span>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
